import React from "react";
import emojis from "./Emojis";

export const EmojiBar = () => {
  return (
    <div className="emojibar" data-test="emojibar">
      <a
        className="emojibar-single-emoji-anchor emojibar-single-emoji-anchor-01"
        href="#"
      >
        <div className="emojibar-single-emoji">{emojis[27]}</div>
      </a>
      <a
        className="emojibar-single-emoji-anchor emojibar-single-emoji-anchor-02"
        href="#"
      >
        <div className="emojibar-single-emoji">{emojis[6]}</div>
      </a>
      <a
        className="emojibar-single-emoji-anchor emojibar-single-emoji-anchor-03"
        href="#"
      >
        <div className="emojibar-single-emoji">{emojis[120]}</div>
      </a>
      <a
        className="emojibar-single-emoji-anchor emojibar-single-emoji-anchor-04"
        href="#"
      >
        <div className="emojibar-single-emoji">{emojis[12]}</div>
      </a>
      <a
        className="emojibar-single-emoji-anchor emojibar-single-emoji-anchor-05"
        href="https://amzn.to/3YwV8We"
        target="_blank"
      >
        <div className="emojibar-single-emoji">{emojis[57]}</div>
      </a>
    </div>
  );
};
